import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ManageCostObjAllocationUnits from "./ManageCostObjAllocationUnits";
import { fetchAllAllocationUnits, selectCostObjAllocationUnit } from 'redux/allocationUnits/AllocationUnitsActions';

const mapStateToProps = ({ allocationUnits }) => ({
  fetchingAllocationUnits: allocationUnits.fetchingAllocationUnits,
  allocationUnits: allocationUnits.allocationUnits
});

const mapDispatchToProps = dispatch => ({
  allocationUnitsActions: bindActionCreators({ fetchAllAllocationUnits, selectCostObjAllocationUnit }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageCostObjAllocationUnits);




// WEBPACK FOOTER //
// ./src/components/manageCostObjs/comp/costObjEditor/ManageCostObjAllocationUnitsConnector.js